import { ApplicationTypes, PlainLocksetHole, attachComponent, featureLabels } from 'metalworks-domain'

import {
  detailComponent,
  distanceDimensionComponent,
  entityHeaderComponent,
  propertyPageComponent,
} from '@salsita-ai/platform-project-sdk/domain'
import { DeleteEntityButton } from '@salsita-ai/platform-project-sdk/react'

import { HolePropertyPage } from '../ui/property-pages/HolePropertyPage'
import { createInnerRadiusDimensionIndicatorComponent } from './common'

export const plainLocksetHoleComponents = [
  // TODO: yaml
  attachComponent
    .withComponent(detailComponent, 'main')
    .withEntity('PlainLocksetHole')
    .attach(() => {
      return {
        title: featureLabels[PlainLocksetHole.type],
        subtitle: 'Adjustable diameter',
        description: 'You can position the hole around the plate.',
        thumbnailUrl: '/thumbnails/circular-hole.png',
      }
    }),
  attachComponent
    .withComponent(propertyPageComponent, 'box')
    .withEntity('PlainLocksetHole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      page: <HolePropertyPage id={s.id} />,
    })),
  attachComponent
    .withComponent(entityHeaderComponent, 'main')
    .withEntity('PlainLocksetHole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      secondaryButton: <DeleteEntityButton entityId={s.id} />,
    })),
  // TODO: yaml
  attachComponent
    .withComponent(distanceDimensionComponent, 'diameter')
    .withEntity('PlainLocksetHole')
    .attach(
      s => ({
        value: s.radius * 2,
        min: 20,
        max: Math.min(100, s.$plate.$maxFeatureSize.x, s.$plate.$maxFeatureSize.y),
        unit: 'mm',
      }),
      v => {
        return {
          // TODO: can this be diameter - it will not be possible to migrate to yaml
          radius: v.value / 2,
        }
      }
    ),
  createInnerRadiusDimensionIndicatorComponent('PlainLocksetHole'),
]
